const STACK_OFFSET = 20;
let currentZIndex = 9999;

function makeDraggable(el: HTMLElement, container: HTMLElement, offsetX = 0, offsetY = 0) {
  let currentX: number;
  let currentY: number;
  let initialX: number;
  let initialY: number;
  let xOffset = offsetX;
  let yOffset = offsetY;
  let active = false;

  container.addEventListener("touchstart", dragStart, false);
  container.addEventListener("touchend", dragEnd, false);
  container.addEventListener("touchmove", drag, false);

  container.addEventListener("mousedown", dragStart, false);
  container.addEventListener("mouseup", dragEnd, false);
  container.addEventListener("mousemove", drag, false);

  const headerEl = el.getElementsByClassName("extbase-debugger-top")[0];
  headerEl.addEventListener("dblclick", () => el.remove());

  setTranslate(xOffset, yOffset, el);

  function dragStart(e: MouseEvent | TouchEvent) {
    if (e.type === "touchstart") {
      initialX = (e as TouchEvent).touches[0].clientX - xOffset;
      initialY = (e as TouchEvent).touches[0].clientY - yOffset;
    } else {
      initialX = (e as MouseEvent).clientX - xOffset;
      initialY = (e as MouseEvent).clientY - yOffset;
    }
    if (e.target === headerEl) {
      active = true;
      el.style.zIndex = String(++currentZIndex);
    }
  }

  function dragEnd(e: MouseEvent | TouchEvent) {
    initialX = currentX;
    initialY = currentY;
    active = false;
  }

  function drag(e: MouseEvent | TouchEvent) {
    if (!active) {
      return;
    }
    e.preventDefault();
    if (e.type === "touchmove") {
      currentX = (e as TouchEvent).touches[0].clientX - initialX;
      currentY = (e as TouchEvent).touches[0].clientY - initialY;
    } else {
      currentX = (e as MouseEvent).clientX - initialX;
      currentY = (e as MouseEvent).clientY - initialY;
    }
    xOffset = currentX;
    yOffset = currentY;
    setTranslate(currentX, currentY, el);
  }

  function setTranslate(xPos: number, yPos: number, el: HTMLElement) {
    el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
  }
}

export function extendExtbaseDebugger() {
  const debuggers = Array.from(document.getElementsByClassName("extbase-debugger"));
  debuggers.forEach((el, i) => makeDraggable(el as HTMLElement, document.body, i * STACK_OFFSET, i * STACK_OFFSET));
}
